import { FC } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { EditSubstitute } from '../editSubstitute';
import { SubstituteView } from '../substituteView';
import { Guid } from '../../shared/types/guid';

export const SubstituteModal: FC<{
  internalNumber: string;
  currentDate: Date;
  onClose: () => void;
  title: string,
  isEdit: boolean,
  substituteId?: Guid,
}> = ({
  internalNumber,
  currentDate,
  onClose,
  title,
  isEdit,
  substituteId = '',
}) => (
  <Dialog
    open
    onClose={onClose}
    maxWidth="md"
    fullWidth
  >
    <div className="align-status">
      <div className="left">
        <DialogTitle>{title}</DialogTitle>
      </div>
      <IconButton sx={{ marginRight: '15px' }} onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </div>
    <DialogContent>
      {isEdit ? (
        <EditSubstitute
          id={internalNumber}
          currentDate={currentDate}
          substituteId={substituteId}
          onClose={onClose}
        />
      ) : (
        <SubstituteView
          id={internalNumber}
          currentDate={currentDate}
          onClose={onClose}
        />
      )}
    </DialogContent>
  </Dialog>
);
